import { useTranslation } from "react-i18next"
import { AppHeader } from "../components/AppHeader";
import { Button, Card } from "antd";
import Icon, { PlusOutlined, EditOutlined, CopyOutlined, DeleteOutlined, CodeSandboxOutlined, TrophyOutlined, ShoppingCartOutlined, GiftOutlined, CrownOutlined, FileDoneOutlined, FormatPainterOutlined, AreaChartOutlined, DollarOutlined, HeatMapOutlined, RobotOutlined, SettingOutlined, BorderlessTableOutlined, StarOutlined } from '@ant-design/icons';
import botconfig from "../botconfig";
import { useParams } from "react-router-dom";
import { message, Popover } from 'antd';
import { login, fetchGuild, fetchSettings, fetchGuilds, fetchUser, fetchGuildItems, fetchGuildAchievements, fetchGuildCategories, fetchGuildGifts, fetchGuildPermissions, fetchGuildPromocodes, fetchGuildQuests, fetchGuildJobs, fetchGuildIncomeRoles, fetchGuildStyles, fetchGuildWormholes, fetchGuildAutogenerators, fetchGuildBonusChannels } from '../api'
import { GuildCardLoader } from "../components/GuildCardLoader";
import { useState, useEffect } from "react";
import Ticket from "../svg/ticket";
const TicketIcon = (props) => <Icon component={Ticket} {...props} />;
export function DashboardPage() {
    const { t } = useTranslation()
    const { guildId } = useParams()
    const [messageApi, contextHolder] = message.useMessage()
    const [settings, setSettings] = useState()
    const [items, setItems] = useState([])
    const [achievements, setAchievements] = useState([])
    const [categories, setCategories] = useState([])
    const [gifts, setGifts] = useState([])
    const [permissions, setPermissions] = useState([])
    const [quests, setQuests] = useState([])
    const [jobs, setJobs] = useState([])
    const [promocodes, setPromocodes] = useState([])
    const [incomeRoles, setIncomeRoles] = useState([])
    const [styles, setStyles] = useState([])
    const [wormholes, setWormholes] = useState([])
    const [autogenerators, setAutogenerators] = useState([])
    const [bonusChannels, setBonusChannels] = useState([])
    const [guild, setGuild] = useState()
    const [loading, setLoading] = useState(true)
    const [errorStatus, setErrorStatus] = useState()
    function errorMessage(error) {
        if (error) console.error(error)
        messageApi.open({
            type: 'error',
            content: t('Произошла ошибка :( ' + error.message),
        });
    }
    useEffect(() => {
        async function fetchData() {
            let user
            let localItem = JSON.parse(localStorage.getItem("wetbot"))
            if (!localItem?.token) return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
            if (localItem.token.expires_at <= Date.now()) {
                localStorage.removeItem("wetbot")
                return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
            } else {
                try {
                    user = await fetchUser(localItem.token)
                } catch (err) {
                    localStorage.removeItem("wetbot")
                    return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
                }
            }
            try {
                let responseGuild
                try {
                    responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                    setGuild(responseGuild)    
                } catch (err) {
                    if (err.response.status === 404) {
                        return setErrorStatus(404)
                    } else if (err.response.status === 401) {
                        await fetchGuilds(user.id, localItem.token.access_token)
                        responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                        setGuild(responseGuild)  
                    } else if (err.response.status === 403) {
                        return setErrorStatus(403)
                    } else {
                        return errorMessage(err)
                    }
                }
                const responseSettings = await fetchSettings(guildId, localItem.token.access_token).then(response => response.response)
                setSettings(responseSettings)
                const responseItems = await fetchGuildItems(guildId, localItem.token.access_token)
                setItems(responseItems)
                const responseAchievements = await fetchGuildAchievements(guildId, localItem.token.access_token)
                setAchievements(responseAchievements)
                const responseCategories = await fetchGuildCategories(guildId, localItem.token.access_token)
                setCategories(responseCategories)
                const responseGifts = await fetchGuildGifts(guildId, localItem.token.access_token)
                setGifts(responseGifts)
                const responsePermissions = await fetchGuildPermissions(guildId, localItem.token.access_token)
                setPermissions(responsePermissions)
                const responsePromocodes = await fetchGuildPromocodes(guildId, localItem.token.access_token)
                setPromocodes(responsePromocodes)
                const responseQuests = await fetchGuildQuests(guildId, localItem.token.access_token)
                setQuests(responseQuests)
                const responseJobs = await fetchGuildJobs(guildId, localItem.token.access_token)
                setJobs(responseJobs)
                const responseIncomeRoles = await fetchGuildIncomeRoles(guildId, localItem.token.access_token)
                setIncomeRoles(responseIncomeRoles)
                const responseStyles = await fetchGuildStyles(guildId, localItem.token.access_token)
                setStyles(responseStyles)
                const responseWormholes = await fetchGuildWormholes(guildId, localItem.token.access_token)
                setWormholes(responseWormholes)
                const responseAutogenerators = await fetchGuildAutogenerators(guildId, localItem.token.access_token)
                setAutogenerators(responseAutogenerators)
                const responseBonusChannels = await fetchGuildBonusChannels(guildId, localItem.token.access_token)
                setBonusChannels(responseBonusChannels)
            } catch (err) {
                errorMessage(err)
            }
            setLoading(false)
        }
        fetchData()
    }, [])
    const itemsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/items`)} disabled={true}>
                    {t('Создать предмет')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/items`)} disabled={true}>
                    {t('Редактировать предмет')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/items`)} disabled={true}>
                    {t('Скопировать предмет')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/items`)} disabled={true}>
                    {t('Удалить предмет')}
                </Button>
            </Popover>
        </div>
    ]
    const achievementsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/achievements`)} disabled={true}>
                    {t('Создать достижение')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/achievements`)} disabled={true}>
                    {t('Редактировать достижение')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/achievements`)} disabled={true}>
                    {t('Скопировать достижение')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/achievements`)} disabled={true}>
                    {t('Удалить достижение')}
                </Button>
            </Popover>
        </div>
    ]
    const categoriesButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/categories`)} disabled={true}>
                    {t('Создать категорию')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/categories`)} disabled={true}>
                    {t('Редактировать категорию')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/categories`)} disabled={true}>
                    {t('Скопировать категорию')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/categories`)} disabled={true}>
                    {t('Удалить категорию')}
                </Button>
            </Popover>
        </div>
    ]
    const giftsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/gifts`)} disabled={true}>
                    {t('Создать подарок')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/gifts`)} disabled={true}>
                    {t('Редактировать подарок')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/gifts`)} disabled={true}>
                    {t('Скопировать подарок')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/gifts`)} disabled={true}>
                    {t('Удалить подарок')}
                </Button>
            </Popover>
        </div>
    ]
    const permissionsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/permissions`)} disabled={true}>
                    {t('Создать право')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/permissions`)} disabled={true}>
                    {t('Редактировать право')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/permissions`)} disabled={true}>
                    {t('Скопировать право')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/permissions`)} disabled={true}>
                    {t('Удалить право')}
                </Button>
            </Popover>
        </div>
    ]
    const promocodesButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/promocodes`)} disabled={true}>
                    {t('Создать промокод')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/promocodes`)} disabled={true}>
                    {t('Редактировать промокод')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/promocodes`)} disabled={true}>
                    {t('Скопировать промокод')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/promocodes`)} disabled={true}>
                    {t('Удалить промокод')}
                </Button>
            </Popover>
        </div>
    ]
    const questsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/quests`)} disabled={true}>
                    {t('Создать квест')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/quests`)} disabled={true}>
                    {t('Редактировать квест')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/quests`)} disabled={true}>
                    {t('Скопировать квест')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/quests`)} disabled={true}>
                    {t('Удалить квест')}
                </Button>
            </Popover>
        </div>
    ]
    const jobsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/jobs`)} disabled={true}>
                    {t('Создать работу')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/jobs`)} disabled={true}>
                    {t('Редактировать работу')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/jobs`)} disabled={true}>
                    {t('Скопировать работу')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/jobs`)} disabled={true}>
                    {t('Удалить работу')}
                </Button>
            </Popover>
        </div>
    ]
    const rolesButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/roles`)} disabled={true}>
                    {t('Создать доходную роль')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/roles`)} disabled={true}>
                    {t('Редактировать доходную роль')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/roles`)} disabled={true}>
                    {t('Удалить доходную роль')}
                </Button>
            </Popover>
        </div>
    ]
    const stylesButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/styles`)} disabled={true}>
                    {t('Создать стиль')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/styles`)} disabled={true}>
                    {t('Редактировать стиль')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/styles`)} disabled={true}>
                    {t('Скопировать стиль')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/styles`)} disabled={true}>
                    {t('Удалить стиль')}
                </Button>
            </Popover>
        </div>
    ]
    const wormholesButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/wormholes`)} disabled={true}>
                    {t('Создать червоточину')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/wormholes`)} disabled={true}>
                    {t('Редактировать червоточину')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/wormholes`)} disabled={true}>
                    {t('Скопировать червоточину')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/wormholes`)} disabled={true}>
                    {t('Удалить червоточину')}
                </Button>
            </Popover>
        </div>
    ]
    const autogeneratorsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/autogenerators`)} disabled={true}>
                    {t('Создать автогенератор')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/autogenerators`)} disabled={true}>
                    {t('Редактировать автогенератор')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<CopyOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/autogenerators`)} disabled={true}>
                    {t('Скопировать автогенератор')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/autogenerators`)} disabled={true}>
                    {t('Удалить автогенератор')}
                </Button>
            </Popover>
        </div>
    ]
    const settingsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/settings`)} disabled={true}>
                    {t('Редактировать')}
                </Button>   
            </Popover>
        </div>
    ]
    const channelsButtons = [
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<PlusOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/channels`)} disabled={true}>
                    {t('Создать бонусный канал')}
                </Button>
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/channels`)} disabled={true}>
                    {t('Редактировать бонусный канал')}
                </Button>   
            </Popover>
            <Popover content={`${t("В разработке")}`}>
                <Button icon={<DeleteOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/channels`)} disabled={true}>
                    {t('Удалить бонусный канал')}
                </Button>
            </Popover>
        </div>
    ]
    if (loading) {
        return (
          <>
            {contextHolder}
            <AppHeader></AppHeader>
            <div className="guilds_container">
              <GuildCardLoader />
            </div>
          </>
        )
    }
    return (
        <>
            {contextHolder}
            <AppHeader></AppHeader>
            <div style={{ display: "flex", justifyContent: "center", paddingTop: 10, alignItems: "center", paddingRight: 20, paddingLeft: 20 }}>
                <img src={guild.iconURL} alt="" style={{ height: 41, borderRadius: "50%" }}/>
                <span className="font-800" style={{ fontSize: 30, textAlign: "center" }}>{guild.name}</span>
            </div>
            <div className="guilds_container">
                <Card
                    style={{ width: 300, borderImage: "linear-gradient(to right, #3acfd5 0%, #3a4ed5 100%) 1" }}
                    actions={[
                        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
                            <Button icon={<EditOutlined />} onClick={() => window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guildId}/premium`)} disabled={false}>
                                {t('Управление')}
                            </Button>
                        </div>
                    ]}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<StarOutlined style={{ fontSize: 32 }}/>}
                    title={t('Премиум')}
                    description={settings.premium.enable ? t(`Премиум активирован. У вас есть доступ ко всем возможностям бота 😋`) : t(`Расширь возможности бота`)}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={itemsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<CodeSandboxOutlined style={{ fontSize: 32 }}/>}
                    title={t("Предметы")}
                    description={`(${items.length}/${settings.premium.enable ? 1000 : settings.max_items})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={achievementsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<TrophyOutlined style={{ fontSize: 32 }}/>}
                    title={t("Достижения")}
                    description={`(${achievements.length}/${settings.premium.enable ? 1000 : settings.max_achievements})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={categoriesButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<ShoppingCartOutlined style={{ fontSize: 32 }}/>}
                    title={t("Категории магазина")}
                    description={`(${categories.length}/${settings.premium.enable ? 25 : settings.max_categories})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={giftsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<GiftOutlined style={{ fontSize: 32 }}/>}
                    title={t("Подарки")}
                    description={`(${gifts.length})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={permissionsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<CrownOutlined style={{ fontSize: 32 }}/>}
                    title={t("Права")}
                    description={`(${permissions.length})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={promocodesButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<TicketIcon style={{ fontSize: 32 }}/>}
                    title={t("Промокоды")}
                    description={`(${promocodes.length}/${settings.premium.enable ? 1000 : settings.max_promocodes})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={questsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<FileDoneOutlined style={{ fontSize: 32 }}/>}
                    title={t("Квесты")}
                    description={`(${quests.length}/${settings.premium.enable ? 1000 : settings.max_quests})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={jobsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<AreaChartOutlined style={{ fontSize: 32 }}/>}
                    title={t("Работа")}
                    description={`(${jobs.length})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={rolesButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<DollarOutlined style={{ fontSize: 32 }}/>}
                    title={t("Доходные роли")}
                    description={`(${incomeRoles.length}/${settings.premium.enable ? 100 : settings.max_roles})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={stylesButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<FormatPainterOutlined style={{ fontSize: 32 }}/>}
                    title={t("Стили червоточин")}
                    description={`(${styles.length}/${settings.premium.enable ? 25 : settings.max_styles})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={wormholesButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<HeatMapOutlined style={{ fontSize: 32 }}/>}
                    title={t("Червоточины")}
                    description={`(${wormholes.length}/${settings.premium.enable ? 100 : settings.max_wormholes})`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={autogeneratorsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<RobotOutlined style={{ fontSize: 32 }}/>}
                    title={t("Автоген. промокодов")}
                    description={`(${autogenerators.length}/25)`}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={settingsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<SettingOutlined style={{ fontSize: 32 }}/>}
                    title={t("Настройки сервера")}
                    />
                </Card>
                <Card
                    style={{ width: 300 }}
                    actions={channelsButtons}
                >
                    <Card.Meta
                    style={{ display: "flex", alignItems: "center" }}
                    avatar={<BorderlessTableOutlined style={{ fontSize: 32 }}/>}
                    title={t("Бонусные каналы")}
                    description={`(${bonusChannels.length}/${settings.premium.enable ? 100 : settings.max_bonusChannels})`}
                    />
                </Card>
            </div>
        </>
    )
}